import React, { useRef } from "react";
import "../assets/css/DemandSheet.css";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

const DemandSheet = () => {
  const sheetRef = useRef();

  const handleDownload = async () => {
    const element = sheetRef.current;
    const canvas = await html2canvas(element, { scale: 2 });
    const imgData = canvas.toDataURL("image/png");

    const pdf = new jsPDF("p", "mm", "a4");
    const pdfWidth = 210;
    const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

    pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
    pdf.save("Demand_Sheet.pdf");
  };

  return (
    < div className="demand-sheet-container">
      <div style={{ textAlign: "right", marginBottom: "10px" }}>
        <button className="download-btn" onClick={handleDownload}>
          ⬇ Download Demand Sheet
        </button>
      </div>

      <div className="demand-sheet-wrapper" ref={sheetRef}>
        <h2 className="demand-sheet-title">Subh Credit Co-Operative Society Limited</h2>
        <h3 className="demand-sheet-subtitle">Collection Demand Sheet</h3>

        {/* Top Info Row */}
        <table className="demand-sheet-table info-table">
          <tbody>
            <tr>
              <td><b>Branch</b></td><td>INDORE</td>
              <td><b>193-01</b></td>
              <td><b>Region</b></td><td>INDORE</td>
              <td><b>Ph No.</b></td><td>9907051434</td>
              <td><b>Coll. Date</b></td><td>02-06-2025</td>
              <td><b>Time</b></td><td>09:00:00</td>
              <td><b>Next Meeting Date</b></td><td>02-07-2025</td>
            </tr>
          </tbody>
        </table>

        {/* Main Table */}
        <table className="demand-sheet-table main-table">
          <thead>
            <tr>
              <th>FO Name</th>
              <th>Center No</th>
              <th>DOB</th>
              <th>Village Name</th>
              <th>Member Name & Membership Number</th>
              <th>Husband Name</th>
              <th>Mobile No</th>
              <th>Outstanding</th>
              <th>EMI No</th>
              <th>Outstanding</th>
              <th>Disbursement Amount</th>
              <th>Today's Demand</th>
              <th>Share/RD Amount</th>
              <th>Total EMI Amount</th>
              <th>Total Coll. Cash</th>
              <th>FD Bond No</th>
              <th>Member Signature</th>
              <th>Attendance</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>KUSHWANT SISODIYA</td>
              <td>105-03</td>
              <td>06-07-2024</td>
              <td>LAHIYA COLONY INDORE</td>
              <td>RADHA BAI 0300600</td>
              <td>MANOJ GOSWAMI</td>
              <td>9977324984</td>
              <td>26740</td>
              <td>11/18</td>
              <td>26740</td>
              <td>50000</td>
              <td>3777</td>
              <td>43</td>
              <td>3820</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>

            <tr>
              <td>KUSHWANT SISODIYA</td>
              <td>105-03</td>
              <td>13-01-2025</td>
              <td>LAHIYA COLONY INDORE</td>
              <td>SEEMA 0302048</td>
              <td>JAYPAL</td>
              <td>9993163578</td>
              <td>26000</td>
              <td>4/12</td>
              <td>26000</td>
              <td>30000</td>
              <td>3100</td>
              <td>150</td>
              <td>3250</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </tbody>
        </table>

        {/* Grand Total Row */}
        <table className="demand-sheet-table total-table">
          <tbody>
            <tr>
              <td><b>GRAND TOTAL</b></td>
              <td colSpan="9"></td>
              <td><b>80000</b></td>
              <td><b>6877</b></td>
              <td><b>193</b></td>
              <td><b>7070</b></td>
              <td colSpan="4"></td>
            </tr>
          </tbody>
        </table>

        {/* Cash Denomination */}
        <div className="demand-sheet-section-title">Cash Denomination Details:-</div>
        <table className="demand-sheet-table denom-table">
          <thead>
            <tr>
              <th>2000 x</th>
              <th>500 x</th>
              <th>200 x</th>
              <th>100 x</th>
              <th>50 x</th>
              <th>20 x</th>
              <th>10 x</th>
              <th>5 x</th>
              <th>Coin</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              {Array(10).fill("").map((_, i) => (
                <td key={i}></td>
              ))}
            </tr>
          </tbody>
        </table>

        {/* Online Transaction */}
        <div className="demand-sheet-section-title">Online Transaction Details:-</div>
        <table className="demand-sheet-table online-table">
          <thead>
            <tr>
              <th>Mode of Pay</th>
              <th>Transaction ID</th>
              <th>Amount</th>
              <th>Mode of Pay</th>
              <th>Transaction ID</th>
              <th>Amount</th>
              <th>Mode of Pay</th>
              <th>Transaction ID</th>
              <th>Amount</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              {Array(10).fill("").map((_, i) => (
                <td key={i}></td>
              ))}
            </tr>
          </tbody>
        </table>

        {/* Footer Section */}
        <div className="demand-sheet-footer-section">
          <div className="demand-sheet-footer-row">FO Comments:</div>

          <div className="demand-sheet-signature-row">
            <div>Signature of Center Leader ............</div>
            <div>Signature of FO ............</div>
            <div>Signature of BM/AM ............</div>
            <div>Signature of Cashier ............</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DemandSheet;